import api from '../api/api'
export async function downloadPDF(setLoadingPDF, url) {
    setLoadingPDF(true)
    const res = await api.get(url, {
        responseType: 'arraybuffer'
    })
    const buffer = res.data
    const blob = new Blob([buffer], { type: 'application/pdf' });
    const _url = window.URL.createObjectURL(blob);
    window.open(_url, '_blank');
    setLoadingPDF(false)
}